import { Container, Heading, Text } from '@chakra-ui/react'

import { makeServerProps } from '@/server/query'

import makePage from '@/client/services/pages/makePage'

import Layout from '@/components/Layout/Layout'

const policies = [
  {
    heading: 'Overview',
    body: `Schoolhouse.world is deeply grateful for the help of our dedicated volunteers.
        This Volunteer Policy explains possible risks of volunteering and includes
        liability waivers, consents, and other legal agreements on your part. Please
        read carefully.`,
  },
  {
    heading: 'Volunteer Hours',
    body: `You understand that Schoolhouse.world will keep track of the number of hours you
        spend volunteering as a tutor. However, you understand that Schoolhouse.world
        makes no promises or guarantees that you will be allotted a certain number of
        volunteer hours.`,
  },
  {
    heading: 'No Representations about Outcomes',
    body: `You acknowledge that Schoolhouse.world is not making any representations, warranties,
        promises, or guarantees of any kind about the outcome of your volunteer experience, including,
        without limitation, college acceptance, job opportunities, or school credit. Schoolhouse.world
        will not be responsible for any financial or other loss incurred by you in connection with
        volunteer activities.`,
  },
  {
    heading: 'No Rights to Make Contracts',
    body: `You agree that you will not make any contracts (or other commitments) for (or on behalf of)
        Schoolhouse.world without the prior written consent of Schoolhouse.world.`,
  },
  {
    heading: 'No Employee Benefits',
    body: `You understand that since you are not an employee of Schoolhouse.world, you are not
        covered by or eligible for any Schoolhouse.world insurance, health care, worker’s compensation,
        or other benefits. The volunteer hours are a donation of services to Schoolhouse.world for public service,
        civic, and charitable objectives without contemplation of pay. You understand that you will not be
        paid for your services.`,
  },
  {
    heading: 'Risks Associated with Volunteering',
    body: `You understand that volunteering for Schoolhouse.world has risks. These risks may include,
        without limitation: data breaches; exposure to computer viruses; unpleasant or harassing interactions
        with individuals on the Schoolhouse.world platform; or exposure to unauthorized individuals in the
        background of or same physical space as a Schoolhouse.world user. You understand further that these
        risks include risks of physical or psychological strain or distress, illness, and property damage or
        loss, and that they may arise from your own actions or from the actions of others.`,
  },
  {
    heading: 'Awareness and Assumption of Risk',
    body: `You understand the information above, and confirm and acknowledge that these are risks associated
        with volunteering. With such information and awareness, and with the recognition that other factors may
        create additional such risks, you knowingly, freely, and voluntarily: (a) sign up to volunteer for
        Schoolhouse.world; (b) engage in volunteer activities; and (c) assume and accept the risks of all injury,
        illness, property damage or loss, financial obligation, loss of privacy, loss of reputation, and all other
        injuries and other consequences, whether known or unknown, whether foreseen or unforeseeable, that may result,
        directly or indirectly, from your participation as a Schoolhouse.world volunteer, regardless of the cause.`,
  },
  {
    heading: 'Waiver and Release of Legal Claims',
    body: `In consideration for your participation as a volunteer, you waive and release Schoolhouse.world and
        its directors, officers, agents, employees, volunteers, and affiliates (collectively, “Released Parties”),
        from any and all liability, claims, costs, and expenses of any kind and of whatever nature which you or
        your heirs, next of kin, or legal representatives may have or which may later accrue, caused by or arising
        directly or indirectly from your participation in Schoolhouse.world activities. This release and waiver
        includes, in each such case, all claims in respect of the risks noted above, known and unknown, foreseen
        and unforeseeable, regardless of the cause or whether such claims arise from tort, contract, or otherwise,
        and even if caused by negligence, whether passive or active. You will not sue any of the Released Parties
        on the basis of these waived and released claims. You waive the protections of Section 1542 of the California
        Civil Code.`,
  },
  {
    heading: 'Confidentiality',
    body: `As a volunteer, you may have access to confidential information, including information about learners,
        other volunteers, tutors, and internal communications relating to our business and operations. Confidential
        information means any information learned by you that is not available to the public concerning matters related
        to Schoolhouse.world, its product roadmap, processes, or users, and any information that a reasonable person would
        understand to be confidential based on the nature of the information and circumstances of disclosure. At all times
        during and after your participation, you agree to maintain the confidentiality of this information and to prevent
        any unauthorized access or use. You will only access and use the confidential information for the purpose of
        serving in your role as a volunteer on behalf of Schoolhouse.world.`,
  },
  {
    heading: 'Security',
    body: `You commit to preserve the safety and confidentiality of Schoolhouse.world and all of our learners and
        tutors. To help protect confidential information and the trust of our entire community, you agree to use
        unique, secure passwords with multi-factor authentication for any Schoolhouse.world account, tool or database
        and will report any reasonably believed security, legal or privacy issues via User Support
        immediately so that we can collaborate and help identify and address any potential issues. You will use
        Schoolhouse.world tools and communication channels only for purposes that are reasonably necessary to fulfill
        your role as a volunteer. At the end of the volunteering (and at any time upon request), you will assist us
        to ensure that access to confidential information and to our accounts and tools is removed.`,
  },
  {
    heading: 'Values',
    body: `You agree to uphold the Schoolhouse.world values. You acknowledge that Schoolhouse.world strictly
        prohibits discrimination and harassment of any kind, including discrimination and harassment on the basis of
        race, color, veteran status, religion, gender, sex, sexual orientation, age, mental or physical disability,
        medical condition, national origin, marital status, or any other characteristics protected under U.S federal
        or state law or local ordinance.`,
  },
  {
    heading: 'Assignment of Work Product',
    body: `You may develop work product in the course of your volunteer activities, including, without limitation,
        curriculum content, tutoring methods, mentoring guidance for learners or the community, user support materials,
        or platform policies. You intend for Schoolhouse.world to have full and exclusive rights to such work product
        and accordingly: (a) assign to Schoolhouse.world all rights, title, and interest worldwide in the work product;
        (b) grant to Schoolhouse.world an irrevocable, exclusive, royalty-free, perpetual, and worldwide license to any
        rights in the work product that cannot be assigned to Schoolhouse.world ; and (c) waive enforcement against
        Client of any rights in the work product that cannot be assigned or licensed to Schoolhouse.world.`,
  },
  {
    heading: 'Publicity',
    body: `You understand that Schoolhouse.world will not use your name, image, or likeness in any format,
        including photos, video, print, or electronic media, without notice and your affirmative consent.`,
  },
  {
    heading: 'General Provisions',
    body: `You understand that this Volunteer Policy will be binding for so long as you are a volunteer at
        Schoolhouse.world. You may stop being a volunteer at any time for any reason. Likewise, we may ask you to
        stop being a volunteer at any time for any reason. This Volunteer Policy will run in favor of, and may be
        enforced by, each of the Released Parties, and will bind your heirs, next of kin, and legal representatives.
        This Volunteer Policy will be binding to the fullest extent permitted by law. If any provision of this Volunteer
        Policy is found to be unenforceable, the other terms remain effective. This Agreement will be governed by
        California law.`,
  },
]

const VolunteerPolicy: React.FC = () => (
  <Layout title="Volunteer Policy">
    <Container>
      <Heading size="3xl" as="h1">
        Volunteer Policy
      </Heading>
      {policies.map(({ heading, body }) => (
        <section key={heading}>
          <Heading size="lg" as="h4" my="16px">
            {heading}
          </Heading>
          <Text>{body}</Text>
        </section>
      ))}
    </Container>
  </Layout>
)

const VolunteerPolicyPage = makePage(VolunteerPolicy, {
  onboardingUsers: 'allowed',
})
export const getServerSideProps = makeServerProps(VolunteerPolicyPage)
export default VolunteerPolicyPage
